// extracted by mini-css-extract-plugin
export var attachment = "_re-a";
export var emailContainer = "_re-4";
export var emailContentPaddedContainer = "_re-b";
export var emailHeader = "_re-6";
export var emailIframe = "_re-3";
export var emailInfoIcon = "_re-9";
export var emailShortenedSummary = "_re-e";
export var infoDropdown = "_re-0";
export var infoRowBoundedContent = "_re-d";
export var internal = "_re-5";
export var merchant = "_re-8";
export var messageInputContainer = "_re-h";
export var normal = "_re-7";
export var replyCard = "_re-f";
export var subtleButton = "_re-1";
export var subtleButtonIconContainer = "_re-2";
export var toggleViewRepliesButton = "_re-c";
export var wrappingText = "_re-g";